/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { authClientsListIssuanceProfiles } from "../funcs/authClientsListIssuanceProfiles.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListIssuanceProfilesResponseBody } from "../models/components/listissuanceprofilesresponsebody.js";
import {
  ListIssuanceProfilesRequest,
  ListIssuanceProfilesSecurity,
} from "../models/operations/listissuanceprofiles.js";
import { unwrapAsync } from "../types/fp.js";
export type IssuanceProfilesQueryData = ListIssuanceProfilesResponseBody;

export function prefetchIssuanceProfiles(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListIssuanceProfilesRequest,
  security?: ListIssuanceProfilesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildIssuanceProfilesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildIssuanceProfilesQuery(
  client$: GramCore,
  request: ListIssuanceProfilesRequest,
  security?: ListIssuanceProfilesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<IssuanceProfilesQueryData>;
} {
  return {
    queryKey: queryKeyIssuanceProfiles({
      userSessionIssuerId: request.userSessionIssuerId,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function issuanceProfilesQueryFn(
      ctx,
    ): Promise<IssuanceProfilesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(authClientsListIssuanceProfiles(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyIssuanceProfiles(
  parameters: {
    userSessionIssuerId: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "authClients", "listIssuanceProfiles", parameters];
}
